import type { ScheduledCopyOverrides } from './scheduled-page-copy-types';

export const scheduledPageCopyOverridesEastAsian = {
  ja: {
    header: {
      navLabel: 'スケジュール',
      title: 'スケジュール',
      subtitle: '指定した時刻に自動実行されるエージェントタスクです。',
      searchPlaceholder: 'スケジュールを検索',
      newSchedule: '新しいスケジュール',
      create: '作成',
      createWithAgent: 'エージェントで作成',
      setUpManually: '手動で設定',
      createWithAgentPrompt:
        'スケジュールタスクの設定を手伝ってください。仕組みを説明し、必要な内容と実行時刻を確認してください。作成前に確認用のプレビューを表示してください。',
      timezone: '{timezone} の時刻で表示',
    },
    filters: {
      all: 'すべて',
      mine: '自分',
      shared: '共有',
      archived: 'アーカイブ',
      filters: 'フィルター',
      moreScopes: 'その他のスケジュール表示',
      status: '状態',
      anyStatus: 'すべての状態',
      active: '有効',
      paused: '一時停止',
      completed: '完了',
    },
    calendar: {
      label: 'スケジュール済みエージェントタスクのカレンダー',
      emptyTitle: '次のスケジュールタスクを計画しましょう',
      more: '他 {count} 件',
      truncated:
        'この期間にはさらに結果があります。日付またはフィルターを絞り込んで、すべて表示してください。',
      offlineTitle: 'オフラインです',
      offlineDescription:
        'スケジュールの読み込みや変更を行うには、再接続してください。',
      malformed: 'このスケジュールを安全に表示できませんでした。',
      loading: 'カレンダーを読み込み中',
      allDay: 'スケジュールのタイムライン',
    },
    common: {
      close: '閉じる',
      cancel: 'キャンセル',
      save: '変更を保存',
      create: 'スケジュールを作成',
      edit: '編集',
      retry: '再試行',
      back: '戻る',
      next: '続ける',
      loading: '読み込み中',
      view: '表示',
      unknown: '不明',
      notAvailable: '利用できません',
    },
  },
  ko: {
    header: {
      navLabel: '예약',
      title: '예약',
      subtitle: '원하는 시간에 자동으로 실행되는 에이전트 작업입니다.',
      searchPlaceholder: '일정 검색',
      newSchedule: '새 일정',
      create: '만들기',
      createWithAgent: '에이전트로 만들기',
      setUpManually: '수동으로 설정',
      createWithAgentPrompt:
        '예약 작업 설정을 도와주세요. 작동 방식을 설명한 다음 무엇이 언제 필요한지 물어보세요. 확인할 수 있도록 미리보기를 보여주세요.',
      timezone: '{timezone} 시간으로 표시',
    },
    filters: {
      all: '전체',
      mine: '내 일정',
      shared: '공유됨',
      archived: '보관됨',
      filters: '필터',
      moreScopes: '기타 일정 보기',
      status: '상태',
      anyStatus: '모든 상태',
      active: '활성',
      paused: '일시 중지',
      completed: '완료',
    },
    calendar: {
      label: '예약된 에이전트 작업 캘린더',
      emptyTitle: '다음 예약 작업을 계획해 보세요',
      more: '{count}개 더',
      truncated:
        '이 기간에 더 많은 결과가 있습니다. 모두 보려면 날짜나 필터 범위를 좁히세요.',
      offlineTitle: '오프라인 상태입니다',
      offlineDescription: '일정을 불러오고 변경하려면 다시 연결하세요.',
      malformed: '이 일정을 안전하게 표시할 수 없습니다.',
      loading: '캘린더 불러오는 중',
      allDay: '일정 타임라인',
    },
    common: {
      close: '닫기',
      cancel: '취소',
      save: '변경 저장',
      create: '일정 만들기',
      edit: '편집',
      retry: '다시 시도',
      back: '뒤로',
      next: '계속',
      loading: '불러오는 중',
      view: '보기',
      unknown: '알 수 없음',
      notAvailable: '사용할 수 없음',
    },
  },
  zh: {
    header: {
      navLabel: '定时任务',
      title: '定时任务',
      subtitle: '按你的时间自动运行的代理任务。',
      searchPlaceholder: '搜索定时任务',
      newSchedule: '新建任务',
      create: '创建',
      createWithAgent: '使用智能体创建',
      setUpManually: '手动设置',
      createWithAgentPrompt:
        '帮我设置一个定时任务。先说明其工作方式，再询问我需要什么以及何时运行。创建前请显示预览供我确认。',
      timezone: '时间以 {timezone} 显示',
    },
    filters: {
      all: '全部',
      mine: '我的',
      shared: '共享',
      archived: '已归档',
      filters: '筛选',
      moreScopes: '更多计划视图',
      status: '状态',
      anyStatus: '所有状态',
      active: '启用',
      paused: '已暂停',
      completed: '已完成',
    },
    calendar: {
      label: '定时代理任务日历',
      emptyTitle: '规划你的下一个定时任务',
      more: '另有 {count} 项',
      truncated: '此时间范围还有更多结果。请缩小日期或筛选条件以查看全部。',
      offlineTitle: '你已离线',
      offlineDescription: '重新连接以加载定时任务并进行更改。',
      malformed: '无法安全显示此定时任务。',
      loading: '正在加载日历',
      allDay: '定时任务时间线',
    },
    common: {
      close: '关闭',
      cancel: '取消',
      save: '保存更改',
      create: '创建任务',
      edit: '编辑',
      retry: '重试',
      back: '返回',
      next: '继续',
      loading: '加载中',
      view: '查看',
      unknown: '未知',
      notAvailable: '不可用',
    },
  },
  'zh-TW': {
    header: {
      navLabel: '排程任務',
      title: '排程任務',
      subtitle: '依你的時間自動執行的代理任務。',
      searchPlaceholder: '搜尋排程',
      newSchedule: '新增排程',
      create: '建立',
      createWithAgent: '使用代理建立',
      setUpManually: '手動設定',
      createWithAgentPrompt:
        '幫我設定一個排程任務。先說明運作方式，再詢問我需要什麼以及何時執行。建立前請顯示預覽供我確認。',
      timezone: '時間以 {timezone} 顯示',
    },
    filters: {
      all: '全部',
      mine: '我的',
      shared: '已共享',
      archived: '已封存',
      filters: '篩選',
      moreScopes: '更多排程檢視',
      status: '狀態',
      anyStatus: '所有狀態',
      active: '啟用',
      paused: '已暫停',
      completed: '已完成',
    },
    calendar: {
      label: '排程代理任務日曆',
      emptyTitle: '規劃你的下一個排程任務',
      more: '另有 {count} 項',
      truncated: '此時間範圍還有更多結果。請縮小日期或篩選條件以查看全部。',
      offlineTitle: '你已離線',
      offlineDescription: '重新連線以載入排程並進行變更。',
      malformed: '無法安全顯示此排程。',
      loading: '正在載入日曆',
      allDay: '排程時間軸',
    },
    common: {
      close: '關閉',
      cancel: '取消',
      save: '儲存變更',
      create: '建立排程',
      edit: '編輯',
      retry: '重試',
      back: '返回',
      next: '繼續',
      loading: '載入中',
      view: '查看',
      unknown: '未知',
      notAvailable: '無法使用',
    },
  },
} satisfies ScheduledCopyOverrides;
